module.exports = __webpack_public_path__ + "facebook.png?60bcab2061aa89973bb3afbc50256bd0";